
import React from "react";
import { Calendar, Clock, Mail, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { LetterActions } from "./LetterActions";

interface Letter {
  id: string;
  delivery_date: string;
  plan_type: string | null;
  owner_email: string;
}

interface AvailableLettersCardsProps {
  letters: Letter[];
  isAdmin: boolean;
  onView: (id: string) => void;
  onShare: (id: string) => void;
  onDownload: (id: string) => void;
  onDelete: (id: string) => void;
}

export function AvailableLettersCards({
  letters,
  isAdmin,
  onView,
  onShare,
  onDownload,
  onDelete
}: AvailableLettersCardsProps) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {letters.map((letter) => (
        <Card key={letter.id} className="hover:shadow-lg transition-shadow duration-200">
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg flex items-center gap-2">
                <Mail className="h-5 w-5 text-green-600" />
                Carta
              </CardTitle>
              <Badge className="bg-green-100 text-green-800">
                <Clock className="h-3 w-3 mr-1" />
                Disponível
              </Badge>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Calendar className="h-4 w-4" />
              <span>
                Entrega: {format(new Date(letter.delivery_date + "T00:00:00"), "dd 'de' MMMM, yyyy", { locale: ptBR })}
              </span>
            </div>
            
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <MapPin className="h-4 w-4" />
              <span className="capitalize">{letter.plan_type || "Padrão"}</span>
            </div>

            {isAdmin && (
              <div className="text-sm text-gray-600">
                <strong>Email:</strong> {letter.owner_email}
              </div>
            )}

            <div className="flex justify-end pt-2">
              <LetterActions
                letterId={letter.id}
                onView={onView}
                onShare={onShare}
                onDownload={onDownload}
                onDelete={onDelete}
              />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
